import React from "react";
import { SERVICES, ModalCtx, makeNavLink } from "./shared.jsx";
import { BookingCalendar } from "./BookingCalendar.jsx";

// Komponenty layoutu: Nav, Footer, Modal

const Modal = ({ onClose }) => {
  React.useEffect(() => {
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", h);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);
  return (
    <div className="modal-backdrop open" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-head">
          <h3>Umów bezpłatną konsultację</h3>
          <button className="modal-close" onClick={onClose} aria-label="Zamknij">✕</button>
        </div>
        <div className="modal-body">
          <BookingCalendar/>
        </div>
      </div>
    </div>
  );
};

const Nav = ({ route, navigate }) => {
  const { open } = React.useContext(ModalCtx);
  const [mob, setMob] = React.useState(false);
  const [drop, setDrop] = React.useState(false);
  const dropTimer = React.useRef(null);
  const openDrop = () => { clearTimeout(dropTimer.current); setDrop(true); };
  const closeDrop = () => { clearTimeout(dropTimer.current); dropTimer.current = setTimeout(() => setDrop(false), 180); };
  const isActive = (r) => route === r || (r === "/uslugi" && route.startsWith("/uslugi"));
  const isOnasActive = route === "/o-nas" || route === "/dlaczego-my" || route === "/technologia";
  // SPA-aware link: real <a href> + onClick → modifier clicks (Cmd/Ctrl/Shift, middle, right)
  // get native browser behavior (open in new tab/window, context menu). Use {...link("/x")}.
  const link = makeNavLink(navigate, () => { setMob(false); setDrop(false); });
  // For real <button> CTAs (no href semantics) — same side-effects, no anchor behavior.
  const go = (r) => () => { navigate(r); setMob(false); setDrop(false); };
  return (
    <>
    <header className="lc-nav">
      <a {...link("/")} aria-label="Let's commerce home">
        <img src="/assets/logo-light.svg" alt="Let's commerce" className="lc-nav-logo" />
      </a>
      <nav className="lc-nav-links">
        <div className="nav-drop-wrap" onMouseEnter={openDrop} onMouseLeave={closeDrop}>
          <a className={"navlink" + (isActive("/uslugi") ? " is-active" : "")} {...link("/uslugi")}>Usługi ▾</a>
          <div className={"nav-drop nav-drop-mega" + (drop ? " open" : "")} onMouseEnter={openDrop} onMouseLeave={closeDrop}>
            <div className="nav-drop-grid">
              {SERVICES.map(s => (
                <a key={s.slug} className="nav-drop-item" {...link(`/uslugi/${s.slug}`)}>
                  <span className="nav-drop-k">{s.k}</span>
                  <div>
                    <div className="nav-drop-n">{s.name}</div>
                    <div className="nav-drop-d">{s.desc}</div>
                  </div>
                </a>
              ))}
            </div>
            <div className="nav-drop-team">
              <span className="nav-drop-team-label">// Poznaj naszą markę „No i cyk" — automatyzacje i AI</span>
              <div className="nav-drop-team-grid">
                <a className="nav-drop-item" href="https://noicyk.pro" target="_blank" rel="noopener noreferrer">
                  <span className="nav-drop-k">↗</span>
                  <div className="nav-drop-n">Audyt procesu</div>
                </a>
                <a className="nav-drop-item" href="https://noicyk.pro/uslugi/konsultacja-30min" target="_blank" rel="noopener noreferrer">
                  <span className="nav-drop-k">↗</span>
                  <div className="nav-drop-n">Konsultacja 30 min</div>
                </a>
                <a className="nav-drop-item" href="https://noicyk.pro" target="_blank" rel="noopener noreferrer">
                  <span className="nav-drop-k">↗</span>
                  <div className="nav-drop-n">Automatyzacje i AI</div>
                </a>
              </div>
            </div>
            <a className="nav-drop-all" {...link("/uslugi")}>Zobacz wszystkie usługi <span style={{fontSize:"13px"}}>↗</span></a>
          </div>
        </div>
        <a className={"navlink" + (isOnasActive ? " is-active" : "")} {...link("/o-nas")}>O nas</a>
        <a className={"navlink" + (isActive("/case-studies") ? " is-active" : "")} {...link("/case-studies")}>Case studies</a>
        <a className={"navlink" + (isActive("/kontakt") ? " is-active" : "")} {...link("/kontakt")}>Kontakt</a>
      </nav>
      <a className="lc-btn lc-btn-primary" {...link("/kontakt")}>
        Umów konsultację <span className="lc-btn-arr">↗</span>
      </a>
      <button className="lc-burger" onClick={() => setMob(!mob)} aria-label="Menu" aria-expanded={mob}>{mob ? "✕" : "☰"}</button>
    </header>
    {/* Mobile menu rendered OUTSIDE <header> — sibling, not child — because
        .lc-nav has backdrop-filter which creates a containing block for fixed
        children, trapping the menu inside the 64px-tall nav. */}
    {mob && (
      <div className="mobile-menu">
        <a {...link("/uslugi")}>Usługi</a>
        {SERVICES.map(s => <a key={s.slug} className="sub" {...link(`/uslugi/${s.slug}`)}>— {s.name}</a>)}
        <a className="sub" href="https://noicyk.pro" target="_blank" rel="noopener noreferrer">— Automatyzacje i AI ↗</a>
        <a {...link("/o-nas")}>O nas</a>
        <a {...link("/case-studies")}>Case studies</a>
        <a {...link("/kontakt")}>Kontakt</a>
        <div style={{marginTop:24}}>
          <a className="lc-btn lc-btn-primary" {...link("/kontakt")}>
            Umów konsultację <span className="lc-btn-arr">↗</span>
          </a>
        </div>
      </div>
    )}
    </>
  );
};

const Footer = ({ navigate }) => {
  const link = makeNavLink(navigate);
  return (
    <footer className="lc-footer">
      <div className="ft-top">
        <div>
          <img src="/assets/logo-light.svg" alt="Let's commerce" className="ft-logo" />
          <div className="ft-addr">
            Gdańsk, Polska<br/>
            Remote-first · pracujemy z całej Polski<br/>
            <a href="mailto:hello@letscommerce.pl" style={{color:"#fff",textDecoration:"none"}}>hello@letscommerce.pl</a><br/>
            <a href="tel:+48690250722" style={{color:"#fff",textDecoration:"none"}}>+48 690 250 722</a>
          </div>
          <div className="ft-badges">
            <span className="ft-badge">Google Partner</span>
            <span className="ft-badge green">Allegro Ads Partner</span>
          </div>
        </div>
        <div className="ft-cols">
          <div className="ft-col">
            <h4>Usługi</h4>
            {SERVICES.map(s => <a key={s.slug} {...link(`/uslugi/${s.slug}`)}>{s.name}</a>)}
            <a href="https://noicyk.pro" target="_blank" rel="noopener noreferrer">Automatyzacje i AI ↗</a>
          </div>
          <div className="ft-col">
            <h4>Agencja</h4>
            <a {...link("/o-nas")}>O nas</a>
            <a {...link("/case-studies")}>Case studies</a>
          </div>
          <div className="ft-col">
            <h4>Kontakt</h4>
            <a {...link("/kontakt")}>Umów konsultację</a>
            <a href="mailto:hello@letscommerce.pl">hello@letscommerce.pl</a>
            <a href="#">LinkedIn</a>
            <a href="#">Instagram</a>
          </div>
          <div className="ft-col">
            <h4>Firma</h4>
            <a>Let's commerce</a>
            <a>NIP: 5783136295</a>
            <a>REGON: 382948473</a>
            <a>Gdańsk, Polska</a>
          </div>
        </div>
      </div>
      <div className="ft-bot">
        <span>© {new Date().getFullYear()} Let's commerce. Wszystkie prawa zastrzeżone.</span>
        <span>
          <a {...link("/polityka-prywatnosci")} style={{color:"inherit",textDecoration:"none"}}>Polityka prywatności</a>
          {" · "}
          <a {...link("/regulamin")} style={{color:"inherit",textDecoration:"none"}}>Regulamin</a>
          {" · "}
          <a href="#" style={{color:"inherit",textDecoration:"none"}} onClick={(e)=>{e.preventDefault();window.dispatchEvent(new Event("lc-open-consent"))}}>Ustawienia cookies</a>
        </span>
      </div>
    </footer>
  );
};

export { Modal, Nav, Footer };
